export const NAMESPACE = "NotificationModal";
export const FORM_INSTANCE_ID = "formInstanceId";
export const PHONE_FIELD_ID = "phoneNumber";
